module.exports = __webpack_public_path__ + "img/calendar-user-circle-green.a6e1e49d.svg";